var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CharacteristicEdit", {
    ref: "edit",
    attrs: {
      title: _vm.title,
      "with-keyword": true,
      "keyword-placeholder": "Organisationsbereich eingeben (mind. 3 Zeichen)",
      "characteristic-type": _vm.meta.organisationalAreaType,
      "characteristic-items": _vm.characteristicItems,
      "nothing-allowed": _vm.nothingAllowed
        ? {
            overall: {
              inFan: true,
              text: "Es sind alle Organisationsbereiche möglich"
            }
          }
        : undefined,
      "title-formats": {
        default:
          "Welchen Organisationsbereich im Bereich<br />%characteristicLabel%?",
        level: {
          1: _vm.title
        }
      },
      "show-multiple-hint": "",
      "open-fan-label": "Organisationsbereiche auswählen",
      "open-fan-label-with-selection": "Organisationsbereiche bearbeiten",
      "label-type": "application",
      "with-edit-button": _vm.withEditButton,
      "open-fan-button-alignment": _vm.buttonAlignment
    },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      }
    },
    model: {
      value: _vm.organisationalArea,
      callback: function($$v) {
        _vm.organisationalArea = $$v
      },
      expression: "organisationalArea"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }